class MemberPermission {
	static GUARDIAN = 0;
	static ADMIN = 1;
	static VIEW_ACTIVITIES = 2;
	static VIEW_FEELINGS = 3;
	static VIEW_PINS = 4;
	static ADD_LAYERS = 5;
	static VIEW_RESOURCES = 6;
	static ADD_RESOURCES = 7;
	static VIEW_GRAPHICS = 8;
	static ADD_GRAPHICS = 9;

	// content filter bits (on content_filter column)
	static FILTER_RESOURCES = 0;
	static FILTER_GRAPHICS = 1;
	static FILTER_LAYERS = 2;

	static defaultValue(type) {
		if (type == Nav.CIRCLE) {
			return (1 << this.VIEW_ACTIVITIES) +
				(1 << this.VIEW_RESOURCES) +
				(1 << this.VIEW_GRAPHICS);
		}
		if (type == Nav.COMMUNITY) {
			return (1 << this.VIEW_ACTIVITIES) +
				(1 << this.VIEW_RESOURCES) +
				(1 << this.VIEW_GRAPHICS);
		}

		return 0;
	}
	
	constructor(member, value, type) {
		if (typeof type == 'undefined') type = nav.entityType;

		if (typeof value == 'undefined') {
			this._value = MemberPermission.defaultValue(type);
		}
		else {
			this._value = value;
		}

		this.member = typeof member == 'undefined' ? null : member;

		this.confirmed = false;

		this.memberTypeOptions = [];
		if (type == Nav.CIRCLE) {
			this.icons = [
				[MemberPermission.VIEW_FEELINGS, 'thumbs', _('View recorded feelings')],
				[MemberPermission.VIEW_PINS, 'pin', _('View recorded pins')],
				[MemberPermission.VIEW_ACTIVITIES, 'layers', _('View timeline activities')],
				[MemberPermission.ADD_LAYERS, 'layer-plus', _('Add or share activity layers with the circle')],
				[MemberPermission.VIEW_RESOURCES, 'resources', _('View the circle resources')],
				[MemberPermission.ADD_RESOURCES, 'resources-add', _('Add or share resources with the circle')],
				[MemberPermission.VIEW_GRAPHICS, 'graphics', _('View the circle graphics')],
				[MemberPermission.ADD_GRAPHICS, 'graphics-add', _("Add or share graphics with the circle")]
			]
			// TODO add checks - don't allow guardian option if owner has family plan or owner is admin of other circles
			// need to check both the circle and the user being added 
			if (
				(nav && nav.unit && nav.unit.isGuardian && (!member || !member.own))
				|| (nav && nav.unit && nav.unit.own && (!member || !member.own))
			 ) {
				this.memberTypeOptions.push(['GUARDIAN', Member.GUARDIAN]);
			}
		}
		else {
			this.icons = [
				[MemberPermission.VIEW_ACTIVITIES, 'layers', _('View community timeline layers')],
				[MemberPermission.ADD_LAYERS, 'layer-plus', _('Add timeline layers to community')],
				[MemberPermission.VIEW_RESOURCES, 'resources', _('View the community resources')],
				[MemberPermission.ADD_RESOURCES, 'resources-add', _('Add or share resources with the community')],
				[MemberPermission.VIEW_GRAPHICS, 'graphics', _('View the community graphics')],
				[MemberPermission.ADD_GRAPHICS, 'graphics-add', _("Add or share graphics with the community")]
			]
		}
		this.memberTypeOptions.push(['ADMIN', Member.ADMIN]);
		this.memberTypeOptions.push(['LIMITED', Member.LIMITED]);

		this.chkBoxes = []; 
		this.rows = [];

		this.buttonIcons = [
			UI.icon('shield', 18),
			UI.icon('user-cog', 18),
			UI.icon('key', 18),
			UI.icon('inherited', 18)
		];

		this.icons.map(i => {
			let chk = UI.chk(i[0], {
				'change': () => {
					this.toggle(i[0]);
				}
			});
			this.chkBoxes.push(chk);
			this.rows.push( UI.div(
				'flex gap-3 justify-between items-center',
				[
					UI.div('flex-0', UI.toggle(chk, [
						UI.div('flex-0', UI.icon(i[1], 22)),
						UI.div('flex-1', i[2])
					]))
				]
			));
		});

		this.typeSelect = UI.select(
			this.memberTypeOptions.map(o =>
				UI.option(o[0], o[1])
			),
			{
				'change': () => {
					this.type = this.typeSelect.value;
				}
			}
		);

		this.elem = UI.div(
			'',
			[
				UI.div(
					'',
					[
						UI.span('', 'Member Type'),
						this.typeSelect
					]
				),
				UI.htm('hr', 'm-2'),
				this.rows
			]
		);
		
		this.update();
	}
	
	get value() {
		return this._value;
	}

	set value(value) {
		this._value = value;
		this.update();
	}

	get type () {
		if (this.can(MemberPermission.GUARDIAN)) return Member.GUARDIAN;
		if (this.can(MemberPermission.ADMIN)) return Member.ADMIN;
		return Member.LIMITED;
	}

	set type(v) {
		if (v == Member.GUARDIAN && !this.confirmed && nav.unit.guardians == 0) {
			Dialog.Confirm(
				_('Once you add a Guardian to this Circle, it will become a protected Circle. Only a guardian can undo this.'),
				_('SET GUARDIAN'),
				() => {
					this.confirmed = true;
					this.type = v;
				}
			);
			return;
		}
		else if (v != Member.GUARDIAN && this.can(MemberPermission.GUARDIAN) && nav.unit.guardians == 1 && !this.confirmed) {
			Dialog.Confirm(
				_('You are about to remove the last Guardian from the circle. The Circle will no longer be protected and the individual at the center will have full permissions.'),
				_('CONTINUE'),
				() => {
					this.confirmed = true;
					this.type = v;
				}
			);
			return;
		}

		switch(parseInt(v)) {
			case Member.GUARDIAN:
				if (this.add(MemberPermission.GUARDIAN)) {
					nav.unit.guardians++;
				}
				this.add(MemberPermission.ADMIN);
				break;
			case Member.ADMIN:
				if (this.rem(MemberPermission.GUARDIAN)) {
					nav.unit.guardians--;
				}
				this.add(MemberPermission.ADMIN);
				break;
			default:
				if (this.rem(MemberPermission.GUARDIAN)) {
					nav.unit.guardians--;
				}
				this.rem(MemberPermission.ADMIN);
		}
		this.confirmed = false;
		this.update();
		this.save();
	}

	get buttonIcon() {
		if (this.type == Member.GUARDIAN) return this.buttonIcons[0];
		if (this.type == Member.ADMIN) return this.buttonIcons[1];
		return this.buttonIcons[2];
	}

	bit(b) {
		return (this._value & (1 << b)) !== 0;
	}

	can(permission) {
		if (permission == MemberPermission.GUARDIAN) return this.bit(MemberPermission.GUARDIAN);

		if (permission == MemberPermission.ADMIN) return this.bit(MemberPermission.ADMIN);

		if (this.bit(MemberPermission.GUARDIAN) || this.bit(MemberPermission.ADMIN)) return true;
		return this.bit(permission);
	}
	
	add(permission) {
		if (this.bit(permission)) return false;
		if (permission == MemberPermission.ADD_LAYERS) this.add(MemberPermission.VIEW_ACTIVITIES);
		if (permission == MemberPermission.ADD_RESOURCES) this.add(MemberPermission.VIEW_RESOURCES);
		if (permission == MemberPermission.ADD_GRAPHICS) this.add(MemberPermission.VIEW_GRAPHICS);
		this._value += (1 << permission);
		return true;
	}
	 
	rem(permission) {
		if (!this.bit(permission)) return false;
		if (permission == MemberPermission.VIEW_ACTIVITIES) this.rem(MemberPermission.ADD_LAYERS);
		if (permission == MemberPermission.VIEW_RESOURCES) this.rem(MemberPermission.ADD_RESOURCES);
		if (permission == MemberPermission.VIEW_GRAPHICS) this.rem(MemberPermission.ADD_GRAPHICS);
		this._value -= (1 << permission);
		return true;
	}

	toggle(permission, ev) {
		if (ev) {
			ev.preventDefault();
			stopEv(ev);
		}

		if (!this.add(permission)) this.rem(permission);
		this.update();
		this.save();
	}
	
	update() {
		this.typeSelect.value = this.type;
		this.chkBoxes.forEach(cb => {
			cb.checked = this.can(cb.value);
			cb.disabled = cb.value != MemberPermission.ADMIN
				&& this.can(MemberPermission.ADMIN);
		});
		if (this.member) {
			this.member.status = Member.ACTIVE;
			this.member.update();
		}
	}

	save() {
		if (this.member == null) return;
		API.update(
			`members/${this.member.id}/permission/${this._value}`
		)
		.then(reply => {
			if (showError(reply)) {
				this.value = reply.value;
			};
		});
	}
}